import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import BottomSheet from './BottomSheet'

interface Option {
  label: string
  value: string
}

interface Props {
  options: Option[]
  selected: string
  onChange: (value: string) => void
}

export default function SortDropdown({ options, selected, onChange }: Props) {
  const [open, setOpen] = useState(false)
  const selectedOption = options.find((o) => o.value === selected)

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="flex items-center gap-1 text-sm active:opacity-70 transition-opacity"
        style={{ color: 'var(--tg-theme-accent-text-color)' }}
      >
        {selectedOption?.label ?? 'Sort'}
        <ChevronDown size={14} />
      </button>

      <BottomSheet open={open} onClose={() => setOpen(false)} title="Sort by">
        <div className="pb-sp-6">
          {options.map((opt) => (
            <button
              key={opt.value}
              onClick={() => {
                onChange(opt.value)
                setOpen(false)
              }}
              className="w-full text-left px-sp-4 py-sp-3 flex items-center justify-between active:opacity-70 transition-opacity"
            >
              <span
                className="text-base"
                style={{
                  color:
                    opt.value === selected
                      ? 'var(--tg-theme-button-color)'
                      : 'var(--tg-theme-text-color)',
                  fontWeight: opt.value === selected ? 600 : 400,
                }}
              >
                {opt.label}
              </span>
              {opt.value === selected && (
                <span style={{ color: 'var(--tg-theme-button-color)' }}>✓</span>
              )}
            </button>
          ))}
        </div>
      </BottomSheet>
    </>
  )
}
